import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaUrls = inject(RmaUrlsService);

  public getUserChatData(): Observable<Record<string, unknown>> {
    return this.httpClient.get<Record<string, unknown>>(this.rmaUrls.apiUrl('Chat/Data'));
  }
}
